import { Component, Input } from '@angular/core';
import { IParamsField, IProductCardForm } from '../../../product/models/models';
import { FormGroup } from '@angular/forms';
import { PHPermissions } from '../../models/PHPermissions';
import { EMPTY_PRODUCT_IMAGE_PATH } from '../../services/products.service';
import { GlobalSettings } from '../../models/globalSettings';
import { SHARED_MODULES } from '../../../shared.';
import { HasAccessPipe } from '../../pipes/has-access.pipe';
import { MeasurementUnitTranslatePipe } from '../../pipes/measurement-unit-translate.pipe';
import { UnitConverterPipe } from '../../pipes/unit-converter.pipe';
import { ImageSelectComponent } from '../image-select/image-select.component';

@Component({
    selector: 'app-product-compression-params',
    templateUrl: './product-compression-params.component.html',
    styleUrls: ['./product-compression-params.component.scss'],
	imports: [SHARED_MODULES, HasAccessPipe, MeasurementUnitTranslatePipe, UnitConverterPipe, ImageSelectComponent],
    standalone: true
})
export class ProductCompressionParamsComponent {

	public fields: Array<IParamsField>;

	protected readonly emptyImagePath: string = EMPTY_PRODUCT_IMAGE_PATH;
	protected readonly emptyInputLabel: string = GlobalSettings.MULTI_SETTINGS_LABEL;
	protected readonly permissions: typeof PHPermissions = PHPermissions;

    @Input() checkboxesView: boolean = false;
	@Input() productDepth: number;
	@Input() productHeight: number;
	@Input() productImage: string;
	@Input() productWidth: number;
	@Input() productForm: FormGroup<IProductCardForm>;
	@Input() showErrors: boolean = false;

	constructor() {}

	ngOnInit(): void {
		this.fields = [
			{
				name: 'height_compression_coef',
				label: 'HEIGHT_COMPRESSION_COEF',
				enableName: 'enableHeightCompression'
			},
			{
				name: 'width_compression_coef',
				label: 'WIDTH_COMPRESSION_COEF',
				enableName: 'enableWidthCompression'
			},
			{
				name: 'depth_compression_coef',
				label: 'DEPTH_COMPRESSION_COEF',
				enableName: 'enableDepthCompression'
			}
		];
	}
}
